import Component from './Component';
import ComponentStyles from './Styles';

export const Styles = ComponentStyles;
export const { TableButtonGroup } = Styles;

export default Component;
